import { api } from 'utility';
import { getCRDUploadedDocsListUrl, getHasheFile, getMetadata, getDownloadableHashFile } from 'URLs';
export async function deleteDocService(data) {
  return api.delete(getCRDUploadedDocsListUrl(), { data });
}
export function getHashe(data) {
  return api.post(getHasheFile(), data).then((res) => res.data);
}
export function getMetaData(id, data) {
  return api.put(getMetadata(id), data).then((res) => res.data);
}
export function getDownloadableHash(uploadHash) {
  return api.get(getDownloadableHashFile(uploadHash)).then((res) => res.data);
}
export default {
  deleteDocService,
  getHashe,
  getMetaData,
  getDownloadableHash
};
